<template>
  <span class="price" :class="containerCss">
    {{$n(value, 'currency')}}
  </span>
</template>

<script>
export default {
  name: 'price',
  props: {
    value: {
      type: Number,
      required: true,
    },
    was: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerCss() {
      return {
        'price--was': this.was,
        'price--default': !this.was,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.price--was {
  position: relative;
}
.price--was:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  right: 0;
  border-top: 1px solid;
  border-color: inherit;
  transform:rotate(-12deg);
}

</style>



// WEBPACK FOOTER //
// Price.vue?ce8c5596